import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LOGO_URL } from "@/config/branding";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await login(email, password);
    if (!result.success) setError(result.error);
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex flex-col" data-testid="login-page">
      {/* Logo Bar */}
      <div className="bg-white/95 backdrop-blur-md border-b border-[#E5E5EA] px-6 py-3">
        <img src={LOGO_URL} alt="Self Certify UK" className="h-12 sm:h-14 object-contain object-left" data-testid="page-logo" />
      </div>

      <div className="flex-1 flex">
        <div className="hidden lg:flex lg:w-1/2 auth-hero items-end justify-start p-12">
          <div className="max-w-md text-white">
            <h1 className="text-4xl sm:text-5xl font-bold tracking-tight mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Certificates &amp; Compliance Made Easy
            </h1>
            <p className="text-base leading-relaxed text-white/60" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
              Electrical certificates, gas safety records, MCS compliance, PAT testing reports, and Part P building notifications — all in one platform.
            </p>
          </div>
        </div>

        <div className="flex-1 flex items-center justify-center p-6 sm:p-12" style={{ backgroundColor: '#F5F5F7' }}>
          <div className="w-full max-w-md animate-fade-in-up">
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#1C1C1E' }}>
              Sign In
            </h2>
            <p className="text-sm mb-8" style={{ color: '#8E8E93' }}>Enter your credentials to access your certificates and documents</p>

            {error && (
              <div className="rounded-xl bg-red-50 p-3 mb-6 text-sm text-red-600 border border-red-200" data-testid="login-error">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-xs font-semibold mb-1.5" style={{ fontFamily: 'Outfit, sans-serif', color: '#8E8E93' }}>
                  Email
                </label>
                <input
                  data-testid="login-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="brutalist-input"
                  placeholder="your@email.com"
                  required
                />
              </div>
              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-xs font-semibold" style={{ fontFamily: 'Outfit, sans-serif', color: '#8E8E93' }}>
                    Password
                  </label>
                  <Link to="/forgot-password" className="text-xs text-[#00A3E0] font-semibold hover:underline" data-testid="forgot-password-link">
                    Forgot password?
                  </Link>
                </div>
                <input
                  data-testid="login-password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="brutalist-input"
                  placeholder="Enter password"
                  required
                />
              </div>
              <button
                data-testid="login-submit-button"
                type="submit"
                disabled={loading}
                className="brutalist-btn w-full"
              >
                {loading ? "Signing in..." : "Sign In"}
              </button>
            </form>

            <p className="mt-6 text-sm text-center" style={{ color: '#8E8E93' }}>
              Don't have an account?{" "}
              <Link to="/register" className="text-[#00A3E0] font-semibold hover:underline" data-testid="register-link">
                Register here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
